import axios from 'axios'

const http = axios.create({
  baseURL: '/ophApi',
  timeout: 1000 * 180,
  withCredentials: true
})

export default http
